import { Grid, makeStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import DataTable from '../../../toolkit/DataTable/DataTable';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import DataView from '../../components/DataView';
import ContainerDataView from './ContainerDataView';
import mercaderiasConfig from './MercaderiasConfig';

const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.short
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  tableCellAction: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  button: {
    margin: 0,
    textDecoration: 'none',
    marginLeft: theme.spacing(1)
  },
  addButon: {
    padding: '15px'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },

  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  cardStyle: {
    borderRadius: '4px 4px 0px 0px'
  },
  tableContainerItem: {
    overflowX: 'auto',
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }
}));

const MercaderiasView = ({ values, isPhone, ...props }) => {
  const { enqueueSnackbar } = props;
  const classes = useStyles();

  const configuraciones = mercaderiasConfig({
    classes,
    enqueueSnackbar
  });
  const dataset = 'mercaderias';
  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const pageSize = props.mercaderia.list?.pagingData?.pageSize || 10;
    const currentPage = props.mercaderia.list?.pagingData?.currentPage || 0;
    props.mercaderia.list.dataLoaded(
      values.mercaderias.slice(
        currentPage * pageSize,
        currentPage * pageSize + pageSize
      ),
      {
        currentPage,
        pageSize,
        itemsCount: values.mercaderias.length
      }
    );
  };

  return (
    <>
      <ContainerDataView title="Mercaderías">
        <Grid container spacing={1} className={classes.tableContainerItem}>
          {values.mercaderias && (
            <Grid item>
              <ListDataProvider
                listStore={props.mercaderia.list}
                render={listProps => (
                  <DataTable
                    title={datosConfig.titulo}
                    disableReload
                    settings={datosSettings}
                    onReloadTable={() => onReloadTable()}
                    fileName={datosConfig.servicio}
                    {...listProps}
                  />
                )}
              />
            </Grid>
          )}
        </Grid>
        <Grid container item xs={12} spacing={isPhone ? 1 : 0}>
          <Grid item xs={12}>
            <DataView
              label="Valor total"
              value={
                values.valorTotal &&
                values.descripcionMoneda &&
                `${values.valorTotal || ''} (${values.descripcionMoneda || ''})`
              }
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Total en dólares"
              value={values.totalDolares}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Peso estimado de la carga (kg.)"
              value={values.pesoEstimadoCarga}
              isPhone={isPhone}
            />
          </Grid>
          <Grid item xs={12}>
            <DataView
              label="Cantidad total"
              value={values.cantidadTotal}
              isPhone={isPhone}
            />
          </Grid>
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default inject('mercaderia')(observer(withSnackbar(MercaderiasView)));
